import { Box, Typography } from '@mui/material';

import { humanizeName } from '../../utils';

import { TSelectedMedication } from '../../constants/types';

interface IPreviewDrawerProps {
  values: TSelectedMedication;
}

const PreviewDrawer = ({ values }: IPreviewDrawerProps) => {
  if (!values) return null;

  const formatAnswer = (answer: string) => {
    if (answer === 'true') return 'On';
    if (answer === 'false') return 'Off';
    if (!answer) return '-';
    return answer;
  };

  const formattedValues = () => {
    return Object.entries(values)
      .map(([key, value]) => {
        if (
          key === 'dosageFrequency' ||
          key === 'reminderEndDate' ||
          key === 'reminderStartDate'
        ) {
          return {
            [key]: null,
          };
        }

        const answer = typeof value === 'boolean' ? `${value}` : value;

        return {
          key: humanizeName(key),
          value: formatAnswer(answer as string),
        };
      })
      .filter(Boolean);
  };

  return (
    <Box>
      {formattedValues().map(({ key, value }) => (
        <Box
          key={key}
          sx={{ gap: 2, ml: 3, mr: 3, pt: 2, lineHeight: '24px' }}
          className="d-flex align-items-center"
        >
          <Typography sx={{ color: 'tertiary.main', fontWeight: '600' }}>
            {key}
          </Typography>
          <Typography sx={{ ml: 'auto' }}>{value}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default PreviewDrawer;
